export const namespaced = true;

export const state = {
  //user: null,
  users: null,
};

export const mutations = {
  SET_USERS(state, users) {
    console.log(users);
    state.users = users;
  },
};
export const actions = {
  setUsers({ commit }, data) {
    console.log(data);
    commit("SET_USERS", data);
  },
};

export const getters = {
  theUsers(state) {
    if (state.users !== null) {
      return state.users;
    } else {
      return [];
    }
  },
};
